<div class="footer-wrapper" role="contentinfo" [style]="config().styles">
  <div class="logos">
    @for (logo of config().logos; track logo.imageUrl) {
      <img class="logo" [src]="logo.imageUrl" [alt]="logo.alternativeText" />
    }
  </div>

  <div class="columns">
    <ul class="footer-links">
      @for (item of config().links; track $index) {
        <li>
          <b2c-footer-link [item]="item" [itemStyles]="config().linkStyles" />
        </li>
      }
    </ul>

    @if (this.backendService.untienotsId) {
      <nav [attr.aria-label]="navbar.navbarAriaLabel">
        <ul>
          @for (item of menuItems(); track $index) {
            <li>
              <a
                class="menu-link"
                [routerLink]="item.url"
                queryParamsHandling="preserve"
                #link="routerLinkActive"
                routerLinkActive="active"
                [attr.aria-current]="link.isActive ? 'page' : null"
                [style]="config().linkStyles"
              >
                {{ item.label }}
              </a>
            </li>
          }
        </ul>
      </nav>
    }
  </div>
</div>
